define("command-palette/decorators/command", ["exports", "@ember/application", "command-palette/command", "command-palette/utils/is-valid-command-id"], function (_exports, _application, _command, _isValidCommandId) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.command = command;
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/application",0,"command-palette/command",0,"command-palette/utils/is-valid-command-id"eaimeta@70e063a35619d71f

  function command(id) {
    return function (target) {
      // Note: ensure the class extends Command
      if (!(target.prototype instanceof _command.Command)) {
        throw new Error('Decorated class must extend Command');
      }

      const ConcreteCommand = target;

      if (!(0, _isValidCommandId.isValidCommandId)(id)) {
        throw new Error(`Command ID "${id}" is invalid - ensure it's in the correct casing/format`);
      } // Note: define a static identifier


      Object.defineProperty(ConcreteCommand, _command.CommandIdentifierKey, {
        value: id,
        writable: false,
        enumerable: true,
        configurable: false
      }); // Note: define a static factory function to align with Ember's dependency injection process

      Object.defineProperty(ConcreteCommand, _command.CommandFactoryFnKey, {
        value: function create(ownerful) {
          const owner = (0, _application.getOwner)(ownerful);

          if (!owner) {
            throw new Error('No owner available on object provided to `create`');
          }

          const instance = new target();
          (0, _application.setOwner)(instance, owner);
          return instance;
        },
        writable: false,
        enumerable: true,
        configurable: false
      });
    };
  }

  var _default = command;
  _exports.default = _default;
});